import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const PlayAltIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M10.496 6.578A1 1 0 0 0 9 7.446v17.108a1 1 0 0 0 1.496.868l14.969-8.554a1 1 0 0 0 0-1.736L10.496 6.578ZM7 7.446C7 5.143 9.488 3.7 11.488 4.842l14.97 8.553c2.015 1.152 2.015 4.058 0 5.21l-14.97 8.553c-2 1.143-4.488-.3-4.488-2.604V7.446Z" />
  </BaseIcon>
);
